/* eslint-disable import/no-dynamic-require */

const router = require.context('./routers')(
  [
    '.',
    process.env.RAZZLE_USE_ROUTER ? 'internal' : 'external',
  ].join('/'),
).default;

export const makeLink = router;
// export default makeLink;

export function makeLinkSimple(path) {
  return path;
}
